import { formatRiskRound } from '@/utils';
import { IconArrowDown, IconArrowUp, Tag, TagProps, Text } from '@cmpsr/components';

type RiskTagProps = {
  risk: number;
  isRiskTrend?: boolean;
  arrowDirection?: 'up' | 'down';
} & TagProps;

export default function RiskTag({ risk, isRiskTrend, arrowDirection, ...props }: RiskTagProps) {
  return (
    <Tag mr="spacer-3" p="spacer-2" size="l" bg="white" border="none" color="primary-default" {...props}>
      <Tag.LeftIcon as={arrowDirection === 'up' ? IconArrowUp : IconArrowDown} />
      <Text variant="text-body-bold">{isRiskTrend ? formatRiskRound(risk) : risk}</Text>
    </Tag>
  );
}
